import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const from = loc.state?.from || "/dashboard";

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email.trim(), password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back");
      if (res.user.role === "admin") nav("/admin");
      else nav(from);
    } else {
      setError(res.error);
    }
  };

  return (
    <div className="min-h-screen bg-[#07080a] noise flex">
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <Link to="/" className="inline-flex items-center gap-3 mb-10">
            <div className="w-8 h-8 rounded-sm bg-gold flex items-center justify-center">
              <span className="font-display text-black text-lg font-bold">V</span>
            </div>
            <span className="font-display text-lg">Vision <span className="text-gold">Fashions</span></span>
          </Link>
          <h1 className="font-display text-4xl md:text-5xl tracking-tight mb-3">Sign in</h1>
          <p className="text-slate-400 mb-10">Access your dashboard, investments and referrals.</p>

          <form onSubmit={onSubmit} className="space-y-6">
            <div>
              <Label className="text-slate-300">Email</Label>
              <Input
                data-testid="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 bg-[#111317] border-[#272a30] focus:border-gold focus:ring-gold text-white h-11"
                placeholder="you@example.com"
              />
            </div>
            <div>
              <Label className="text-slate-300">Password</Label>
              <Input
                data-testid="login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 bg-[#111317] border-[#272a30] focus:border-gold focus:ring-gold text-white h-11"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <div data-testid="login-error" className="text-sm text-red-400 border border-red-500/30 bg-red-500/5 p-3 rounded-md">
                {error}
              </div>
            )}
            <Button
              data-testid="login-submit"
              type="submit"
              disabled={busy}
              className="w-full bg-gold text-black hover:bg-[#f3e396] h-11 rounded-full"
            >
              {busy ? "Signing in…" : "Sign in"}
            </Button>
            <div className="text-sm text-slate-400 text-center">
              New here?{" "}
              <Link to="/register" data-testid="login-to-register" className="text-gold hover:underline">
                Create an account
              </Link>
            </div>
          </form>
        </div>
      </div>
      <div className="hidden md:block flex-1 relative">
        <img
          src="https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjByZWFsJTIwZXN0YXRlJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzg0MTA3NTYzfDA&ixlib=rb-4.1.0&q=85"
          className="absolute inset-0 w-full h-full object-cover"
          alt=""
        />
        <div className="absolute inset-0 bg-gradient-to-l from-black/60 via-black/30 to-[#07080a]" />
      </div>
    </div>
  );
}
